import { Div, Flex, Link, Text, type LinkProps } from "@hopper-ui/components";
import type { ReactNode } from "react";

interface Props extends Partial<LinkProps> {
    icon: ReactNode;
    title: string;
    href: string;
}

export const LinkItem = ({ icon, title, href, color = "primary" }: Props) => {
    return (
        <Div borderBottom="neutral-weakest" borderFocus="none">
            <Link
                href={href}
                UNSAFE_width="100%"
                display="block"
                isQuiet
                borderRadius="core_0"
                UNSAFE_border="0.125rem solid transparent"
                UNSAFE_borderFocus="0.125rem solid var(--hop-primary-border-focus)"
                boxShadowFocus="none"
                backgroundColorHover="neutral-weakest"
                textDecoration="none"
                padding="inset-md"
                outline="none"
            >
                <Flex alignItems="center" gap="inline-sm" className="wai-channel-header">
                    {icon}
                    <Text
                        color={color}
                        fontSize="body-xs"
                        lineHeight="body-xs"
                    >
                        {title}
                    </Text>
                </Flex>
            </Link>
        </Div>
    );
};
